import gql from 'graphql-tag';

export default gql`
  fragment CriticalPathTasks on myTasks {
    criticalPathTasks {
      id
    }
  } 
`




// WEBPACK FOOTER //
// ./src/fragments/criticalPaths.js